<template>
  <div class="card card-custom gutter-b" style="height: 95%">
    <v-overlay :value="carregando" :absolute="true">
      <v-progress-circular indeterminate size="32" color="#462181" width="2"
        ><v-progress-circular
          indeterminate
          size="24"
          color="#ff7f00"
          width="2"
          rotate="180"
        ></v-progress-circular
      ></v-progress-circular>
    </v-overlay>
    <b-modal
      ref="mdlDetalhes"
      title="Detalhes da Campanha"
      ok-title="Fechar"
      ok-variant="secondary"
      ok-only
      size="xl"
      scrollable
    >
      <b-table :fields="cabecalhoAtual" :items="linhas" hover small>
        <template #cell(acionada)="data">
          <p v-for="(v, k) in data.value" :key="k" class="mb-0">{{ v }}</p>
        </template>
        <template #cell(acoes)="data">
          <p v-for="(v, k) in data.value" :key="k" class="mb-0">{{ v }}</p>
        </template>
      </b-table>
    </b-modal>
    <div class="card-body p-0 h-100" style="position: relative">
      <div
        v-show="is_arrow_left_visible"
        id="SetaEsquerdaHoverable"
        @mouseover="hoveringSetaEsquerda"
        @mouseleave="leavingHoverSetaEsquerda"
        @click="clickSetinhaEsquerda"
      >
        <i class="fa fa-chevron-left"></i>
      </div>
      <div
        v-show="is_arrow_right_visible"
        id="SetaDireitaHoverable"
        @mouseover="hoveringSetaDireita"
        @mouseleave="leavingHoverSetaDireita"
        @click="clickSetinhaDireita"
      >
        <i class="fa fa-chevron-right"></i>
      </div>
      <div class="d-flex justify-content-between card-spacer flex-grow-1 h-100">
        <div class="d-flex flex-column w-100">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="d-flex flex-column align-items-start w-50">
              <div class="d-flex align-items-center">
                <h5 class="m-0 mr-3">Percentual de Respostas</h5>
                <Tooltip
                  message="Os gráficos representam os envios e respostas de diferentes tipos de campanhas. É importante notar que um mesmo usuário pode ter respondido mais de uma vez, o que pode resultar em um aumento na taxa de respostas. O centro do gráfico mostra o percentual de respostas de cada campanha."
                />
              </div>
              <span v-if="!graficosFiltrados.length"
                >Sem dados para amostra</span
              >
            </div>
            <slot></slot>
          </div>
          <br />
          <div
            class="d-flex pb-4 h-100"
            style="
              gap: 3rem;
              overflow: hidden;
              overflow-y: hidden !important;
              margin: 0 32px 0 32px !important;
            "
            :style="{
              'justify-content':
                graficosFiltrados.length < 3 ? 'center' : 'start'
            }"
            ref="PieChartContainer"
          >
            <div
              v-for="(card, k) in dadosAgendas"
              :key="'campanha-pie-chart-custom' + k"
            >
              <CampanhaPieChartCustom
                v-if="
                  card.dados.reduce((acc, curr) => acc + curr.valor, 0) > 50
                "
                :titulo="card.titulo"
                :data="card.dados"
                @abrirDetalhesCampanhaEstatistica="detalhesAgenda"
              />
            </div>

            <CampanhaPieChart
              v-for="(card, k) in dados"
              :titulo="card.campanha"
              :enviado="card.enviado"
              :recebido="+card.recebido"
              :percentual="card.percentual"
              :key="'campanha-pie-chart-' + k"
              :card_id="card.id"
              @abrirDetalhesCampanhaEstatistica="detalhes"
            />
            <div
              v-for="(card, k) in npsItens()"
              :key="'campanha-pie-chart-custom2' + k"
            >
              <CampanhaPieChartCustom
                :titulo="card.titulo"
                :data="card.dados"
                colorLabel="color"
                :reverse="false"
                @abrirDetalhesCampanhaEstatistica="detalhesOpine"
              />
            </div>
            <div
              v-if="!graficosFiltrados.length"
              class="d-flex justify-content-center align-items-center h-100"
            >
              <img src="/logo.png" alt="" style="height: 250px; opacity: 0.5" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CampanhaPieChart from "./CampanhaPieChart.vue";
import ApiService from "@/core/services/api.service";
import Tooltip from "./Tooltip.vue";
import CampanhaPieChartCustom from "./CampanhaPieChartCustom.vue";

export default {
  props: {
    carregando: {
      type: Boolean,
      required: true
    },
    dados: {
      type: Array,
      required: true
    },
    dadosAgendas: {
      type: Array,
      required: true
    },
    dadosNps: {
      type: Array,
      required: true
    },
    agruparNps: {
      type: Boolean,
      default: false
    },
    periodo: {
      required: true
    },
    exibirCampanhasSemCallback: {
      type: Boolean,
      required: true
    },
    datepicker: {
      type: Object,
      required: true
    }
  },
  components: {
    CampanhaPieChart,
    CampanhaPieChartCustom,
    Tooltip
  },
  watch: {
    dados() {
      this.refreshChartsPreservingScroll();
    },
    dadosAgendas() {
      this.refreshChartsPreservingScroll();
    },
    dadosNps() {
      this.refreshChartsPreservingScroll();
    },
    scroll_left_state() {
      //
    }
  },
  data() {
    return {
      resize_handler: null,
      scroll_left_state: 0,
      is_arrow_left_visible: true,
      is_arrow_right_visible: true,
      scrolling_left_frame: null,
      scrolling_right_frame: null,
      chartOptions: {
        chart: {
          type: "donut",
          toolbar: {
            show: false
          }
        },
        labels: ["Envios", "Respostas"],
        dataLabels: {
          enabled: false
        },
        legend: {
          position: "bottom",
          horizontalAlign: "center"
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  show: true,
                  fontSize: "16px",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  fontWeight: 400,
                  color: undefined,
                  offsetY: 16,
                  formatter: function (val) {
                    return val;
                  }
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: "engajamento",
                  fontSize: "20px",
                  color: "#373d3f",
                  formatter: function (w) {
                    return w.globals.seriesTotals[0] + "%";
                  }
                }
              }
            }
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              }
            }
          }
        ]
      },
      chartSeries: [44, 55],
      cabecalho: [
        {
          key: "campanha",
          label: "Modelo",
          sortable: false,
          class: "align-middle"
        },
        {
          key: "existe_callback",
          label: "Callback?",
          sortable: false,
          class: "align-middle text-center"
        },
        {
          key: "enviado",
          label: "Enviado",
          sortable: false,
          class: "align-middle text-center"
        },
        {
          key: "recebido",
          label: "Recebido",
          sortable: false,
          class: "align-middle text-center"
        },
        {
          key: "acionada",
          label: "Acionada",
          sortable: false,
          class: "align-middle text-center"
        },
        {
          key: "acoes",
          label: "Ações",
          sortable: false,
          class: "align-middle text-center"
        },
        {
          key: "percentual",
          label: "% Respostas",
          sortable: false,
          class: "align-middle text-center",
          formatter: this.formatarPercentual
        }
      ],
      cabecalhoAgenda: [
        {
          key: "login",
          label: "Conta",
          sortable: false,
          class: "align-middle"
        },
        {
          key: "status",
          label: "Status",
          sortable: false,
          class: "align-middle"
        },
        {
          key: "sincronismo",
          label: "Sincronismo",
          sortable: false,
          class: "align-middle text-center"
        },
        {
          key: "agendas",
          label: "Agendas",
          sortable: false,
          class: "align-middle text-center"
        },
        {
          key: "clientes",
          label: "Clientes",
          sortable: false,
          class: "align-middle text-center"
        }
      ],
      cabecalhoOpine: [
        {
          key: "conta",
          label: "Conta",
          sortable: false,
          class: "align-middle"
        },
        {
          key: "total",
          label: "Total de envios",
          sortable: false,
          class: "align-middle  text-center"
        },
        {
          key: "respostas",
          label: "Total de Respostas",
          sortable: false,
          class: "align-middle text-center"
        },
        {
          key: "sem_retorno",
          label: "Sem Retorno",
          sortable: false,
          class: "align-middle text-center"
        },
        {
          key: "valor_percentual",
          label: "% Respostas",
          sortable: false,
          class: "align-middle text-center"
        }
      ],
      cabecalhoAtual: this.cabecalho,
      linhas: []
    };
  },
  computed: {
    graficosFiltrados() {
      const dadosAgendaFiltrado = this.dadosAgendas.filter(
        (card) => card.dados.reduce((acc, curr) => acc + curr.valor, 0) > 50
      );

      const dadosNpsFiltrado = this.npsItens().filter(
        (card) => card.dados.reduce((acc, curr) => acc + curr.valor, 0) > 50
      );
      let itens = [...this.dados, ...dadosAgendaFiltrado, ...dadosNpsFiltrado];
      return itens;
    }
  },
  methods: {
    refreshChartsPreservingScroll() {
      const container = this.getScrollContainer();
      const previousScrollLeft = container ? container.scrollLeft : 0;
      this.scroll_left_state = previousScrollLeft;

      this.$nextTick(() => {
        const updatedContainer = this.getScrollContainer();
        if (!updatedContainer) return;

        const maxScrollLeft = this.getMaxScrollLeft();
        this.scroll_left_state = Math.min(previousScrollLeft, maxScrollLeft);
        updatedContainer.scrollLeft = this.scroll_left_state;
        this.updateArrowVisibility();
      });
    },
    getScrollContainer() {
      return this.$refs.PieChartContainer;
    },
    getMaxScrollLeft() {
      const container = this.getScrollContainer();

      if (!container) return 0;
      return Math.max(0, container.scrollWidth - container.clientWidth);
    },
    updateArrowVisibility() {
      const container = this.getScrollContainer();

      if (!container) return;

      const maxScrollLeft = this.getMaxScrollLeft();
      const currentScrollLeft = container.scrollLeft;
      const hasOverflow = maxScrollLeft > 1;

      this.is_arrow_right_visible =
        hasOverflow && currentScrollLeft < maxScrollLeft + 5;
      this.is_arrow_left_visible = hasOverflow && currentScrollLeft > 0;

      if (!this.is_arrow_right_visible) {
        this.leavingHoverSetaDireita();
      }

      if (!this.is_arrow_left_visible) {
        this.leavingHoverSetaEsquerda();
      }
    },
    hoveringSetaEsquerda() {
      this.startAutoScroll("left");
    },
    leavingHoverSetaEsquerda() {
      this.stopAutoScroll("left");
    },
    clickSetinhaEsquerda() {
      const container = this.getScrollContainer();
      if (!container) return;

      if (!this.is_arrow_left_visible) return;

      this.scroll_left_state = Math.max(0, this.scroll_left_state - 100);
      container.scrollLeft = this.scroll_left_state;
      this.updateArrowVisibility();
    },
    hoveringSetaDireita() {
      this.startAutoScroll("right");
    },
    leavingHoverSetaDireita() {
      this.stopAutoScroll("right");
    },
    clickSetinhaDireita() {
      const container = this.getScrollContainer();
      if (!container) return;

      if (!this.is_arrow_right_visible) return;

      const maxScrollLeft = this.getMaxScrollLeft();
      this.scroll_left_state = Math.min(
        this.scroll_left_state + 100,
        maxScrollLeft
      );
      container.scrollLeft = this.scroll_left_state;
      this.updateArrowVisibility();
    },
    detalhes(id) {
      this.$refs.mdlDetalhes.show();
      ApiService.post("/dashboard/cards-campanha", {
        periodo: this.periodo,
        agrupamento: "modelo",
        campanha: id,
        exibirCampanhasSemCallback: this.exibirCampanhasSemCallback
      }).then((res) => {
        const dados = res.data.data.campanhas;

        if (dados) {
          this.linhas = dados.flatMap((item) => {
            if (!item.possibilidades_resposta) {
              // Return the item as-is or handle differently if needed
              return [item];
            }
            return {
              ...item,
              acionada: Object.keys(item.possibilidades_resposta),
              acoes: Object.values(item.possibilidades_resposta)
            };
          });
        }
        this.cabecalhoAtual = this.cabecalho;
        this.$refs.mdlDetalhes.show();
      });
    },
    detalhesAgenda(id) {
      this.$refs.mdlDetalhes.show();
      ApiService.post("/dashboard/cards-campanha", {
        periodo: this.periodo,
        agrupamento: "modelo",
        exibirCampanhasSemCallback: this.exibirCampanhasSemCallback
      }).then((res) => {
        const dados = res.data.data.dados_agenda;

        if (dados) {
          this.linhas = dados.flatMap((item) => {
            if (!item.possibilidades_resposta) {
              // Return the item as-is or handle differently if needed
              return [item];
            }
            return {
              ...item,
              acionada: Object.keys(item.possibilidades_resposta),
              acoes: Object.values(item.possibilidades_resposta)
            };
          });
          this.cabecalhoAtual = this.cabecalhoAgenda;
          this.$refs.mdlDetalhes.show();
        }
      });
    },
    detalhesOpine(id) {
      this.$refs.mdlDetalhes.show();
      ApiService.post("/dashboard/cards-campanha", {
        periodo: {
          dataInicial: this.datepicker.dataInicioFim.startDate,
          dataFinal: this.datepicker.dataInicioFim.endDate,
          periodo: this.periodo
        },
        agrupamento: "modelo",
        exibirCampanhasSemCallback: this.exibirCampanhasSemCallback
      }).then((res) => {
        const dados = res.data.data.grafico_nps;

        if (dados) {
          this.linhas = dados.flatMap((item) => {
            return {
              ...item
            };
          });
          this.cabecalhoAtual = this.cabecalhoOpine;
          this.$refs.mdlDetalhes.show();
        }
      });
    },
    formatarPercentual(n) {
      return n.toFixed(1) + "%";
    },
    startAutoScroll(direction) {
      const isLeft = direction === "left";
      const frameKey = isLeft
        ? "scrolling_left_frame"
        : "scrolling_right_frame";

      if (this[frameKey]) {
        cancelAnimationFrame(this[frameKey]);
        this[frameKey] = null;
      }

      const step = () => {
        const container = this.getScrollContainer();
        if (!container) {
          this[frameKey] = null;
          return;
        }

        const maxScrollLeft = this.getMaxScrollLeft();
        const current = container.scrollLeft;
        const nextScrollLeft = isLeft
          ? Math.max(0, current - 5)
          : Math.min(current + 5, maxScrollLeft);

        if (nextScrollLeft === current) {
          this[frameKey] = null;
          this.updateArrowVisibility();
          return;
        }

        this.scroll_left_state = nextScrollLeft;
        container.scrollLeft = nextScrollLeft;
        this.updateArrowVisibility();

        this[frameKey] = requestAnimationFrame(step);
      };

      this[frameKey] = requestAnimationFrame(step);
    },
    stopAutoScroll(direction) {
      const frameKey =
        direction === "left" ? "scrolling_left_frame" : "scrolling_right_frame";

      if (this[frameKey]) {
        cancelAnimationFrame(this[frameKey]);
        this[frameKey] = null;
      }
    },
    npsItens() {
      if (!this.agruparNps) {
        return this.dadosNps;
      }

      if (this.dadosNps.length === 0) {
        return [];
      }

      const itens = [...this.dadosNps];

      const consolidado = itens.reduce(
        (acc, item) => {
          acc.total += Number(item.total || 0);
          acc.respostas += Number(item.respostas || 0);
          acc.sem_retorno += Number(item.sem_retorno || 0);

          return acc;
        },
        {
          titulo: "Opine",
          total: 0,
          respostas: 0,
          sem_retorno: 0
        }
      );

      if (consolidado.total === 0) {
        return [];
      }

      consolidado.valor_percentual =
        consolidado.total > 0
          ? Number(
              ((consolidado.respostas / consolidado.total) * 100).toFixed(1)
            )
          : 0;

      // Consolida os dados preservando labels e cores
      const dadosMap = {};

      itens.forEach((item) => {
        (item.dados || []).forEach((dado) => {
          if (!dadosMap[dado.label]) {
            dadosMap[dado.label] = {
              label: dado.label,
              valor: 0,
              color: dado.color
            };
          }

          dadosMap[dado.label].valor += Number(dado.valor || 0);
        });
      });

      consolidado.dados = Object.values(dadosMap).map((dado) => ({
        ...dado,
        valor_percentual:
          consolidado.total > 0
            ? Number(((dado.valor / consolidado.total) * 100).toFixed(1))
            : 0
      }));

      consolidado.conta = "Todas";

      return [consolidado];
    }
  },

  mounted() {
    this.resize_handler = () => this.updateArrowVisibility();
    window.addEventListener("resize", this.resize_handler);

    this.$nextTick(() => {
      const container = this.getScrollContainer();
      this.scroll_left_state = container ? container.scrollLeft : 0;
      this.updateArrowVisibility();
    });
  },
  beforeDestroy() {
    this.stopAutoScroll("left");
    this.stopAutoScroll("right");
    window.removeEventListener("resize", this.resize_handler);
  }
};
</script>

<style lang="scss" scoped>
.card {
  transition: 0.3s ease;
  &:hover {
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  }
}
#SetaEsquerdaHoverable {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  background: #472282;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 90;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  &:hover {
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  }
  i {
    color: #fff;
    font-size: 1rem;
  }
}
#SetaDireitaHoverable {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  background: #472282;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 90;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  &:hover {
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  }
  i {
    color: #fff;
    font-size: 1rem;
  }
}
</style>
